import { useMutation, useQuery } from "@tanstack/react-query";
import newApi from "src/newApi";
import { queryClient } from "src/queryClient";
import { getService } from "../helpers/isPes";
import options from "./defaultOptions";

export function useGetNotes(id: number, enabled: boolean) {
	return useQuery({
		queryKey: [`notes-${getService()}-${id}`],

		queryFn: async () => {
			const notes = await newApi.getNote(id);
			if (!notes.length) {
				return [];
			}

			return {
				...notes[0],
				note: notes[0].notatka,
			};
		},

		...options,
		enabled: !!enabled,
		gcTime: 60 * 1000,
	});
}

interface AddNotePayload {
	id: number;
	note: string;
}

export const useAddNote = () =>
	useMutation<unknown, unknown, AddNotePayload>({
		mutationFn: ({ id, note }) => newApi.addNote(id, note),
		onSuccess: async (_data, { id }) => {
			await Promise.all([
				queryClient.invalidateQueries({
					queryKey: [`notes-${getService()}-${id}`],
				}),
				queryClient.refetchQueries({ queryKey: ["exam-question", id] }),
				queryClient.invalidateQueries({ queryKey: ["questions"] }),
			]);
		},
	});
